import { Box, Paper } from "@mui/material";
import { ColDef } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { useState } from "react";
import { useCastersContext } from "../../../CastersContext";
import { useTableStyles } from "../../../styles/useTableStyles";
import { useHousingTableData } from "./hooks/useHousingTableData";
import { EditStrandModal } from "./modals/EditStrandModal";

interface Props {
	refreshData: Function;
}

export const HousingTable = ({ refreshData }: Props) => {
	const { state, actions } = useCastersContext();
	const classes = useTableStyles();
	const strands = state.strands || [];

	const [strandIdForEdit, setStrandIdForEdit] = useState<string>("");

	const onEditButtonClick = (id: string) => {
		actions.setRefreshInPause(true);
		setStrandIdForEdit(id);
	};

	const { columns, defaultColDef, rowData } = useHousingTableData(
		strands,
		onEditButtonClick,
	);

	const styledColumns = columns.map((col: ColDef, index: number) => {
		if (index !== 0 && index % 2 === 0) {
			return {
				...col,
				cellStyle: {
					...col.cellStyle,
					backgroundColor: "rgba(245, 245, 245, 0.67)",
				},
			};
		}
		return col;
	});

	return (
		<>
			<Paper className={classes.borderAgGridTable} elevation={0}>
				<Box p={0}>
					<div className={`${classes.materialTable}`}>
						<AgGridReact
							rowSelection="single"
							suppressRowClickSelection={true}
							pagination={false}
							singleClickEdit={false}
							tooltipShowDelay={0}
							tooltipHideDelay={2000}
							rowData={rowData}
							columnDefs={styledColumns}
							domLayout="normal"
							getRowId={(params) => {
								return params.data.id;
							}}
						/>
					</div>
				</Box>
			</Paper>
			<EditStrandModal
				show={!!strandIdForEdit}
				onHide={(shouldUpdate) => {
					setStrandIdForEdit("");
					if (shouldUpdate) {
						refreshData();
					}
					actions.setRefreshInPause(false);
				}}
				strandId={strandIdForEdit}
			/>
		</>
	);
};
